import React from "react";
import Spinner from "../../Plateforme/Atoms/Spinner";
import * as api from "../../api";
import { useTranslation } from 'react-i18next';
import { NeedToPay } from "../Utils/Validator";
import BlueButton from "../Atoms/BlueButton";

const ConfirmPayment = (props) => {

    const { i18n } = useTranslation('common');

    const [paymentSaved, setPaymentSaved] = React.useState(false);
    const [timestampStartedAt, setTimestampStartedAt] = React.useState(null);
    const [recheckTimeout, setRecheckTimeout] = React.useState(null);
    // const [pageRefreshedOnce, setPageRefreshedOnce] = React.useState(false);

    //we're expecting a get parm named "returnurl" that will be the url to go to after the payment is saved
    const returnUrl = decodeURIComponent(new URLSearchParams(window.location.search).get("returnurl")) || "/annuaire";

    React.useEffect(() => {
        if(!props.fullUserLoading && props.fullUser) {
            if(!props.fullUser.hsProfile) {
                api.LogFront("Error in ConfirmPayment.js: User hsProfile is null, this shouldnt happen. We told the user that it was all good.", true);
                setPaymentSaved(true);
                return;
            }
            if(timestampStartedAt) {
                const timestampNow = new Date().getTime();
                if(timestampNow - timestampStartedAt > 10000) {
                    api.LogFront("Error in ConfirmPayment.js: User payment still not saved after 10 seconds, this shouldnt happen. We told the user that it was all good.", true);
                    setPaymentSaved(true);
                    return;
                }
            }
            if(NeedToPay(props.fullUser.hsProfile)) {
                if(recheckTimeout) {
                    clearTimeout(recheckTimeout);
                }
                setRecheckTimeout(setTimeout(props.refreshUser, 2000));
                if(!timestampStartedAt){
                    setTimestampStartedAt(new Date().getTime());
                }
            }else {
                setPaymentSaved(true);
            }
        }
    }, [props.fullUser, props.fullUserLoading]);

    if(props.fullUserLoading || !paymentSaved) {
        return (<>
            <p>{i18n.language === 'fr' ? "Veuillez patienter, nous enregistront votre paiement..." : "Please wait, we are saving your payment..."}</p>
            <br/>
            <br/>
            <Spinner/>
        </>);
    }

    if(!props.fullUser) {
        api.LogFront("Error in ConfirmPayment.js: fullUser is null, this shouldnt happen");
        return i18n.language === 'fr' ? "Veuillez vous connecter." : "Please log in.";
    }

    return (<>
        <h2>{i18n.language === 'fr' ? "Paiement enregistré" : "Payment saved"}</h2>
        <br/>
        <br/>
        <p>{i18n.language === 'fr' ? "Votre paiement a bien été enregistré." : "Your payment has been saved."}</p>
        <br/>
        <br/>
        <BlueButton onClick={() => window.location.href = decodeURIComponent(returnUrl)}>{i18n.language === 'fr' ? "Fermer" : "Close"}</BlueButton>
    </>);
};

export default ConfirmPayment;